/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import mixpanelConstants from "../common/mixpanelConstants";
import Classes from "../common/Classes";
import classnames from "classnames";
import MediaQuery from 'react-responsive';
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Tags = (props) => {
  const {
    tags, detailPageLink, sponserCategory, showHeading, categoriesLabel
  } = props;
  if (isEmpty(tags)) return null;
  const exhTags = sponserCategory ? tags.filter(tag => tag !== sponserCategory) : tags
  return (
      <>
        <MediaQuery maxWidth={767}>
          {exhTags.length > 0 ?
            <div className={Classes.tagIcon} data-testId='tag-icon'>
              <FontAwesomeIcon icon={faTag} />
            </div>
            : null}
        </MediaQuery>
      <div>
        {(showHeading && exhTags) &&
            <h4 className={classnames(Classes.textLeft, Classes.titleInExhibitorSummary)}>{categoriesLabel}</h4>}
        <span
          className={Classes.ppsTags}
          data-testId='exh-tags'
          onClick={() => props.triggerMixpanelEvent(mixpanelConstants.element.filterTag)}>
          <a
            href={detailPageLink}
          >
            {exhTags.join(', ')}
          </a>
        </span>
      </div>
      </>
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  detailPageLink: PropTypes.string.isRequired,
  triggerMixpanelEvent: PropTypes.func,
  sponserCategory: PropTypes.string,
  showHeading: PropTypes.bool,
  categoriesLabel: PropTypes.string.isRequired
};

export default Tags;
